import { useMount, useUnmount } from 'react-use';

const DEFAULT_DESCRIPTION =
    'Snazzy Maps is a repository of different color schemes for Google Maps aimed towards web designers and developers.';
const DEFAULT_KEYWORDS = 'google,maps,google maps,styled maps,styles,color,schemes,themes';

export const useMetaTags = (description, keywords) => {
    useMount(() => {
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) metaDescription.setAttribute('content', description);

        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords) metaKeywords.setAttribute('content', keywords);
    });

    useUnmount(() => {
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) metaDescription.setAttribute('content', DEFAULT_DESCRIPTION);

        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords) metaKeywords.setAttribute('content', DEFAULT_KEYWORDS);
    });
};
